import { createRoot } from 'react-dom/client';
import React, { useState } from 'react';
import 'ress/ress.css';
import './css/index.scss';
import style from './css/index.module.scss';
import { Footer } from './Footer/Footer';
import { About } from './About/About';
import { Achievements } from './Achievements/Achievements';
import { Blogs } from './Blogs/Blogs';
import { Contact } from './Contact/Contact';
import { Home } from './Home/Home';
import { Header } from './Header/Header';
import { ImageArea } from './ImageArea/ImageArea';
// import { SlideMenuArea } from './SlideMenuArea/SlideMenuArea';

const App: React.FC = () => {
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const onclick = () => {
    setIsMenuVisible(!isMenuVisible);
  };

  return (
    <div className={style.wrapper}>
      <div
        className={style.contentBox + (isMenuVisible ? ' ' + style.move : '')}
      >
        <Header onClick={onclick}></Header>
        <ImageArea></ImageArea>
        <div>
          <Home></Home>
          <Achievements></Achievements>
          <About></About>
          <Blogs></Blogs>
          <Contact></Contact>
        </div>
        <Footer></Footer>
      </div>
      <div className={style.menuBox + (isMenuVisible ? ' ' + style.move : '')}>
        {/* <SlideMenuArea /> */}
        <nav>
          <ul>
            <li>MENU</li>
            <li>MENU</li>
            <li>MENU</li>
          </ul>
        </nav>
        <div className={style.overlay}></div>
      </div>
    </div>
  );
};

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
